import { useMemo } from "react";
import { resources } from "@constants/hardcoded-strings";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { ServiceOfferingRefreshRate } from "@idw-types/data/reference-data/generic";
import { FormattedRpServiceConfigurationServiceOffering } from "@idw-types/data/rp-service-configuration";
import { ContentPageBody } from "../../../../common/content-page-body/content-page-body";
import { ContentPageHeader } from "../../../../common/content-page-header/content-page-header";
import { ServiceOfferingRefreshRateSelect } from "./service-offering-refresh-rate-select/service-offering-refresh-rate-select";
import commonStyles from "../../verification-service-details-component.less";

type FederatedIdpReverificationTabContainerProps = {
    isDisabled: boolean;
    serviceOfferingRefreshRateDefault: string;
    serviceOfferingRefreshRates: Array<ServiceOfferingRefreshRate>;
    serviceOfferings: Array<FormattedRpServiceConfigurationServiceOffering>;
    updateServiceOffering: (serviceOffering: FormattedRpServiceConfigurationServiceOffering) => void;
};

export const FederatedIdpReverificationTabContainer = (props: FederatedIdpReverificationTabContainerProps) => {
    const {
        isDisabled,
        serviceOfferingRefreshRateDefault,
        serviceOfferingRefreshRates,
        serviceOfferings,
        updateServiceOffering
    } = props;

    const refreshRateOptions = useMemo(() => {
        return serviceOfferingRefreshRates.map(sorr => ({
            label: sorr.value,
            value: sorr.key
        }));
    }, [serviceOfferingRefreshRates]);

    const defaultRefreshRateOption = useMemo(() => {
        return refreshRateOptions.find(sorr => sorr.value === serviceOfferingRefreshRateDefault);
    }, [refreshRateOptions, serviceOfferingRefreshRateDefault]);

    return (
        <div>
            <ContentPageHeader title={resources.pages.verificationServiceDetails.tabs.federatedIdp.subTabs.reverification.title} />
            <ContentPageBody isMaxWidth={true}>
                <span className={commonStyles.description}>
                    {resources.pages.verificationServiceDetails.tabs.federatedIdp.subTabs.reverification.description}
                </span>
                <div>
                    {serviceOfferings.map(so => (
                        <ServiceOfferingRefreshRateSelect
                            key={`federated-idp-service-offering-${so.serviceOfferingID}`}
                            isDisabled={isDisabled}
                            labelWidth={LabelWidthTypes.LARGE}
                            layout={LayoutTypes.ROW}
                            refreshRateOptions={refreshRateOptions}
                            defaultRefreshRateOption={defaultRefreshRateOption}
                            serviceOffering={so}
                            updateServiceOffering={updateServiceOffering}
                        />
                    ))}
                </div>
            </ContentPageBody>
        </div>
    );
};